import { createContext, useContext } from 'react';

/**
 * Shows a page of the document under review. Null, the default, leaves page labels as plain text, so
 * `Evidence` needs no props threaded through every card that quotes the document.
 */
export const DocumentPageContext = createContext<((page: number) => void) | null>(null);

export const useDocumentPage = () => useContext(DocumentPageContext);
